const routePaths = {
  // Public routes
  home: "/",
  about: "/gioi-thieu",
  programs: "/chuong-trinh",
  programDetail: "/chuong-trinh/:slug",
  schedule: "/lich-khai-giang",
  teachers: "/doi-ngu-giao-vien",
  results: "/ket-qua-hoc-vien",
  blog: "/blog",
  blogDetail: "/blog/:slug",
  contact: "/dang-ky",

  // Test routes
  testList: "/kiem-tra",
  testPage: "/kiem-tra/:id",
  testPageResult: "/ket-qua/:id",
  testIntro: "/kiem-tra/:id/gioi-thieu",

  // Auth routes
  user: "/users",
  teacher: "/teacher",
  userRegister: "/users/dang-ky-tai-khoan",
  login: "/dang-nhap",
  profile: "/users/ho-so",
  myResults: "/users/my-results",
  accountSettings: "/users/account-settings",

  forgotPassword: "/forgot-password",

  // Admin routes
  admin: "/admin",
  adminPages: "/admin/pages",
  adminBlogs: "/admin/blogs",
  adminHighlights: "/admin/highlights",
  adminScheduleIntro: "/admin/schedule-intro",
  adminUsers: "/admin/users",
  adminNewSection: "/admin/sections/new",
  adminTestimonials: "/admin/testimonials",
  adminPrograms: "/admin/programs",
  adminTests: "/admin/tests",
  adminTestNew: "/admin/tests/new",
  adminSiteInfo: "/admin/siteinfo",

  STUDENT_ASSIGNMENTS: "/students/assignments",
  studentAssignments: "/students/assignments",
  teacherClasses: "/teacher/classes",


  // ===== Helpers =====
  helpers: {
    programDetail: (slug) => `/chuong-trinh/${slug}`,
    blogDetail: (slug) => `/blog/${slug}`,
    testPage: (id, assignmentId, classId) => `/kiem-tra/${id}?assignmentId=${assignmentId||''}&classId=${classId||''}`,
    testPageResult: (id, historyId) => `/ket-qua/${id}?historyId=${historyId}`,
    testIntro: (id) => `/kiem-tra/${id}/gioi-thieu`,
    profile: (userId) => `/users/ho-so/${userId}`, // nếu có dynamic user
    adminSectionEdit: (id) => `/admin/sections/${id}`,
    adminPageEdit: (id) => `/admin/pages/${id}`,
    adminBlogEdit: (id) => `/admin/blogs/${id}`,
    adminProgramEdit: (id) => `/admin/programs/${id}`,
    adminTestEdit: (id) => `/admin/tests/${id}`,
  }
};

export default routePaths;
